import React, { useEffect, useState } from "react";
import Table from "../ui/Table";
import VirtualTable from "../ui/VirtualTable";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import { SortIcon } from "../utils/Icons";
import { bm_date, drawPOSStatus, drawPrice, istl } from "../utils/Utils";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from "dayjs";
import Space from "../ui/Space";
import Card from "../ui/Card";
import Label from "../ui/Label";
import Divider from "../ui/Divider";

export default function POSItems(props) {

    const {
        signal = {},
        loading = false,
        setLoading = () => { },
        data = [],
        setData = () => { },
        selected = 0,
        setSelected = () => { },
        route = "",
        align = "auto",
        setAlign = () => { },
        view = false,
    } = props;


    const buffer = 20;


    const columns = [
        { min: true, width: 50, key: "available_onhand", align: "right", title: <>aOH</> },
        { min: true, width: 130, key: "class", align: "left", title: <>Class</> },
        { min: true, width: 100, grow : true,  key: "title", align: "left", title: <>Title</> },
        { min: true, width: 130, key: "cust_po", align: "left", title: <>CustPo</> },
        { min: true, width: 150, key: "primary_code", align: "left", title: <>ISBN</> },
        { min: true, width: 50, key: "quantity", align: "left", title: <>Qty</> },
        { min: true, width: 80, key: "price", align: "right", title: <>price</> },
        { min: true, width: 40, key: "discount", align: "right", title: <>%</>, render : () => { return "99"} },
        { min: true, width: 50, key: "tax_code", align: "right", title: <>Tax</> },
        { min: true, width: 50, key: "points", align: "right", title: <>Pts</> },
        { min: true, width: 80, key: "total_price", align: "left", title: <>Total</> },
    ];


    const next = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        setAlign("auto");

        const nextIndex = data.findIndex(item => item?.invoice === selected?.invoice) + _rows;
        if (data.length <= nextIndex) {
            setSelected(data[data.length - 1]);
        }

        if (nextIndex < data.length) {
            setSelected(data[nextIndex]);
        }
    };

    const prev = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.invoice === selected?.invoice) - _rows;
        if (prevIndex < 0) {
            setSelected(data[0]);
            return;
        }
        if (prevIndex >= 0) {
            setSelected(data[prevIndex]);
        }
    };





    return (
        <div style={{ "display": (view) ? "none" : "block", "padding": "0px 15px" }}>
            <Label style={{ "textAlign": "left" }}>&nbsp;Search Results:</Label>
            <div className="shim" />
            <Space size={10}  style={{ "alignItems": "start" }}>
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 600 }}>
                    <VirtualTable
                        onWheel={(e) => (e.deltaY > 0) ? next() : prev()}
                        onRowClick={(item, event, index) => { setAlign("auto"); setSelected(item) }}
                        next={next}
                        prev={prev}
                        align={align}
                        row_key={"point_of_sale_id"}
                        current={{}}
                        data={data}
                        height={251}
                        columns={columns}
                        width={0}
                        loading={loading}
                        offset={430}
                        route={route}
                    />
                </div>
                <Card header={<Label style={{ "textAlign": "left" }}>POS Transaction Log</Label>} style={{ "width": "282px" }} secondary>
                    <Label>POS Transaction Log</Label>
                </Card>
            </Space>
        </div>
    )
}